exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-activated-modal__info {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  padding: 3rem 6rem 0;\n}\n\n.not-activated-modal__info svg {\n  width: 13.8rem;\n  height: 13.8rem;\n}\n\n.not-activated-modal__info h3 {\n  color: #0d3a52;\n}\n\n", ""]);

// exports
